import React from 'react';

import styles from '../AnswerSet.module.scss';

import ValueListChoice from './ValueListChoice';
import { ValueListNaChoice } from './ValueListNaChoice';

function ValueListChoiceList({
  answerSetId,
  isStandard,
  choices,
  includeNA,
  naText,
  onChoiceUpdate,
  onChoiceDelete,
}) {
  return (
    <table>
      <thead>
        <tr>
          {!isStandard && <td className={styles['drag-column']}></td>}
          <th></th>
          <th className={styles.shifted}>Value</th>
          {!isStandard && <td></td>}
        </tr>
      </thead>
      <tbody>
        {choices.map((choice, i) => (
          <ValueListChoice
            key={choice.guid}
            choice={choice}
            answerSetId={answerSetId}
            isStandard={isStandard}
            className={styles['answer']}
            onUpdate={onChoiceUpdate}
            onDelete={onChoiceDelete}
            index={i}
          />
        ))}
        {includeNA && (
          <ValueListNaChoice text={naText} isStandard={isStandard} />
        )}
      </tbody>
    </table>
  );
}

export default ValueListChoiceList;
